import React, { useEffect, useState } from 'react'

import { RenderFunctionResult } from 'react-on-rails/node_package/lib/types'

import fireChat from 'fireChat'
import useCurrent from 'Hooks/useCurrent'
import useEvent from 'Hooks/useEvent'
import useToggle from 'Hooks/useToggle'
import { ReactComponent as MessageSquare } from 'Icons/message-square.svg'
import { ReactComponent as X } from 'Icons/x.svg'
import { CustomRailsContext } from 'Types'

import GQLProvider from 'Components/GQLProvider'

import AuthProvider, { useChatAuth } from './AuthProvider'
import ChatBox from './ChatBox'
import useChat from './hooks/useChat'

const Chat = () => {
  const current = useCurrent()
  const [locationId, setLocationId] = useState<string>(`${current.locationId}`)
  const { signInAnonymously, loading } = useChatAuth()
  const [{ chat }] = useChat(locationId)

  const [open, , show, hide] = useToggle()
  const unreadCount = chat?.unreads?.customer ?? 0

  const handleShow = useEvent(() => {
    show()

    void signInAnonymously().catch(() => {})
  })

  useEffect(() => {
    if (chat?.id && open) {
      void fireChat.markAsRead(chat.id)
    }
  }, [chat?.id, open])

  return (
    <>
      <div className={`chat__launcher ${open ? 'is-active' : ''}`}>
        <button
          aria-label="Open chat"
          className="chat__launcher-open js-open-chat-trigger"
          disabled={loading}
          onClick={handleShow}
        >
          <MessageSquare />
        </button>

        <button aria-label="Close chat" className="chat__launcher-close" onClick={hide}>
          <X />
        </button>

        {unreadCount && !open ? <div className="chat__launcher-badge">{unreadCount}</div> : null}
      </div>
      <ChatBox chat={chat} locationId={locationId} open={open} setLocationId={setLocationId} onClose={hide} />
    </>
  )
}

const Wrapper = (_: unknown, reactContext: CustomRailsContext): RenderFunctionResult => {
  const Wrapped = () => (
    <GQLProvider serverSide={reactContext.serverSide}>
      <AuthProvider>
        <Chat />
      </AuthProvider>
    </GQLProvider>
  )
  return Wrapped
}

export default Wrapper
